import { SystemEntity } from '@erp/shared-types';
import { Badge } from '@/components/ui/badge';
import {
  HoverCard,
  HoverCardTrigger,
  HoverCardContent,
} from '@/components/ui/hover-card';
import { cn } from '@/lib/utils';
import { ShoppingCartIcon } from '@phosphor-icons/react';
import { SystemEntityPreview } from '../preview-ui';
import { useSalesOrder } from '@/api/rpc/hooks/accounts-receivable/useSalesOrders';

interface SalesOrderInlineProps {
  entityType: SystemEntity; // Required by inline component registry but not used - type is always AR_SALES_ORDER
  entityId: string;
  className?: string;
}

export function SalesOrderInline({
  entityId,
  className,
}: SalesOrderInlineProps) {
  const { data: salesOrderData, isLoading } = useSalesOrder(entityId);

  const soNumber = isLoading
    ? 'Loading...'
    : salesOrderData?.salesOrder?.customerPurchaseOrderNumber ||
      salesOrderData?.salesOrder?.internalId?.toString() ||
      'Unknown';

  return (
    <HoverCard openDelay={200} closeDelay={200}>
      <HoverCardTrigger asChild>
        <div className="inline-block">
          <Badge
            variant="outline"
            className={cn('gap-1.5 cursor-pointer', className)}
          >
            <ShoppingCartIcon className="size-3" />
            <span>
              <span className="text-muted-foreground font-mono">SO</span>{' '}
              {soNumber}
            </span>
          </Badge>
        </div>
      </HoverCardTrigger>
      <HoverCardContent
        className="w-auto p-0 pointer-events-auto"
        align="start"
        side="bottom"
        sideOffset={2}
        onPointerEnter={(e) => e.stopPropagation()}
        onPointerLeave={(e) => e.stopPropagation()}
      >
        <SystemEntityPreview
          entityType={SystemEntity.AR_SALES_ORDER}
          entityId={entityId}
        />
      </HoverCardContent>
    </HoverCard>
  );
}
